import secureLocalStorage from "react-secure-storage";
import { CircularProgress } from "@material-ui/core";
import { process } from "@progress/kendo-data-query";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import React, { Component } from "react";
import Api from "../../Services/Api";
import ExistingControlCell from "../Tenant/Component/ExistingControlCell";
import ImpactEditComponent from "../Tenant/Component/ImpactEditComponent";
import PrePostComponenant from "../Tenant/Component/PrePostComponenant";
import RiskCauseCell from "../Tenant/Component/RiskCauseCell";
import RiskDescriptionCell from "../Tenant/Component/RiskDescriptionCell";
import StatusComponent from "../Tenant/Component/StatusComponent";
import ActionDataSetView from "./ActionDataSetView";
import { MitigationDetails } from "./MitigationDetails";
import * as moment from "moment";
import { formatNumber } from "@telerik/kendo-intl";
import { filterBy, orderBy } from "@progress/kendo-data-query";
import { CustomFieldSearchMenu } from "../Dashboard/CustomFieldSearchMenu";
import { SingleDropDownCheckboxFilter } from "../Dashboard/SingleDropDownCheckboxFilter";
import ColumnMenuFilter from "../Dashboard/ColumnMenuFilter";
import { SearchMenu } from "../Dashboard/SearchMenu";
import { ColumnMenuCheckboxFilter } from "../Dashboard/ColumnMenuCheckboxFilter";
import QualitativeImpactEditComponent from "../Tenant/Component/QualitativeImpactEditComponent";
import { SingleDropDownCheckboxCommonFilter } from "../Dashboard/SingleDropDownCheckboxCommonFilter";
import ViewTaskDataset from "../Tasks/ViewTaskDataset";
import ViewActivitiesDataset from "../Tasks/ViewActivitiesDataset";

export default class ViewActionRiskDataset extends Component {
  constructor(props) {
    super(props);
    this.state = this.createAppState({
      ...this.state,
      sort: [{ field: "code", dir: "asc" }],
      take: 10,
      skip: 0,
      mitigationData: [],
      loader: false,
      HeatMapConfigDataOpportunity: [],
      HeatMapConfigDataThreat: [],
      dynamicHeatmapProbabilityRange: [],
      existingFilter: [],
      riskTypemaster: [],
      filter: {
        logic: "and",
        filters: [],
      },
      riskTypemaster: [],
      riskTemp: [],
      customFieldsmaster: [],
      selectedColumn: undefined,
      selectedIds: [],
      riskList: [],
      userList: [],
      actionTypeList: [],
      taskDataList: [],
      taskActionDataList: [],
    });
    this.expandChange = this.expandChange.bind(this);
  }

  componentDidMount() {
    this.init();
  }

  init = async () => {
    if (this.props.isFreezeDS) {
      //Frozen datasets
      if (
        this.props.chartData &&
        !this.props.chartData.isActionWidget &&
        this.props.chartData.reportType !== "Task" &&
        this.props.chartData.reportType !== "TaskAction"
      ) {
        await this.getMatrixColorCodes();
        await this.getCustomField();
        this.getFrozenRiskDataByViewId(this.props.chartData);
      } else if (
        this.props.chartData &&
        this.props.chartData.isActionWidget &&
        this.props.chartData.reportType !== "Task" &&
        this.props.chartData.reportType !== "TaskAction"
      ) {
        this.getFrozenActionDataByViewId(this.props.chartData);
      }
    } else {
      //Non-Frozen datasets
      if (
        this.props.chartData &&
        !this.props.chartData.isActionWidget &&
        this.props.chartData.reportType !== "Task" &&
        this.props.chartData.reportType !== "TaskAction"
      ) {
        await this.getMatrixColorCodes();
        await this.getCustomField();
        this.getRiskDataByViewId(this.props.chartData);
      } else if (
        this.props.chartData &&
        this.props.chartData.isActionWidget &&
        this.props.chartData.reportType !== "Task" &&
        this.props.chartData.reportType !== "TaskAction"
      ) {
        this.getActionDataByViewId(this.props.chartData);
      } else if (
        this.props.chartData &&
        this.props.chartData.reportType === "Task"
      ) {
        await this.getCustomField();
        this.getTaskDatasetView(this.props.chartData);
      } else if (
        this.props.chartData &&
        this.props.chartData.reportType === "TaskAction"
      ) {
        await this.getCustomField();
        this.getTaskActionDatasetView(this.props.chartData);
      }
    }
    this.getRiskTypeList();
    this.getCustomField();
    this.getAllTenantUserList();
    this.getActionTypeList();
  };

  getTaskDatasetView = async (datasetObj) => {
    try {
      console.log("viewId", datasetObj);
      this.setState({ ...this.state, loader: true });
      var request = {
        viewId: datasetObj.dataSourceId,
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      };
      let response = await Api.getTaskDatasetView(request);
      if (response.status === 200) {
        response.taskRegisters.map((riskReg) => {
          if (riskReg.originalCompletionDate) {
            riskReg.originalCompletionDate = new Date(
              riskReg.originalCompletionDate
            ); //riskReg.originalCompletionDate? moment(new Date(riskReg.originalCompletionDate)).format("DD-MMM-YYYY"):null;
          }
          if (riskReg.projectedCompletionDate) {
            riskReg.projectedCompletionDate = new Date(
              riskReg.projectedCompletionDate
            ); //riskReg.projectedCompletionDate? moment(new Date(riskReg.projectedCompletionDate)).format("DD-MMM-YYYY"):null;
          }
          if (riskReg.actualCompletionDate) {
            riskReg.actualCompletionDate = new Date(
              riskReg.actualCompletionDate
            ); //riskReg.actualCompletionDate? moment(new Date(riskReg.actualCompletionDate)).format("DD-MMM-YYYY"):null;
          }
          if (riskReg.proximityAlertDate) {
            riskReg.proximityAlertDate = new Date(riskReg.proximityAlertDate); //riskReg.proximityAlertDate? moment(new Date(riskReg.proximityAlertDate)).format("DD-MMM-YYYY"):null;
          }
          if (riskReg.updatedDate) {
            var time = moment(riskReg.updatedDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let updatedDate = time;
            riskReg.updatedDate = riskReg.updatedDate
              ? new Date(updatedDate)
              : "";
          }
          if (riskReg.createdDate) {
            let time = moment(riskReg.createdDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let createdDate = time;
            riskReg.createdDate = riskReg.createdDate
              ? new Date(createdDate)
              : "";
          }
          if (riskReg.closedDate) {
            let time = moment(riskReg.closedDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let closedDate = time;
            riskReg.closedDate = riskReg.closedDate ? new Date(closedDate) : "";
          }

          if (riskReg.isClosed === false) {
            riskReg.isClosed = "Open";
          } else {
            riskReg.isClosed = "Closed";
          }
          if (riskReg.isApproved === false) {
            riskReg.isApproved = "No";
          } else {
            riskReg.isApproved = "Yes";
          }
        });
        //CheckBox
        var taskData = [];
        if (!response.isFiltered) {
          taskData = response.taskRegisters.map((dataItem) =>
            Object.assign({ selected: true }, dataItem)
          );
        } else {
          taskData = response.taskRegisters.map((dataItem) =>
            Object.assign({ selected: false }, dataItem)
          );
        }
        this.setState({ ...this.state, loader: false, taskDataList: taskData });
      } else {
        this.setState({ ...this.state, loader: false, taskDataList: [] });
      }
    } catch (err) {
      this.setState({ ...this.state, loader: false, taskDataList: [] });
    }
  };

  getTaskActionDatasetView = async (datasetObj) => {
    try {
      console.log("viewId", datasetObj);
      this.setState({ ...this.state, loader: true });
      var request = {
        viewId: datasetObj.dataSourceId,
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      };
      let response = await Api.getTaskActionDatasetView(request);
      if (response.status === 200) {
        response.taskActions.map((riskReg) => {
          if (riskReg.originalCompletionDate) {
            riskReg.originalCompletionDate = new Date(
              riskReg.originalCompletionDate
            ); //riskReg.originalCompletionDate? moment(new Date(riskReg.originalCompletionDate)).format("DD-MMM-YYYY"):null;
          }
          if (riskReg.projectedCompletionDate) {
            riskReg.projectedCompletionDate = new Date(
              riskReg.projectedCompletionDate
            ); //riskReg.projectedCompletionDate? moment(new Date(riskReg.projectedCompletionDate)).format("DD-MMM-YYYY"):null;
          }
          if (riskReg.actualCompletionDate) {
            riskReg.actualCompletionDate = new Date(
              riskReg.actualCompletionDate
            ); //riskReg.actualCompletionDate? moment(new Date(riskReg.actualCompletionDate)).format("DD-MMM-YYYY"):null;
          }
          if (riskReg.proximityAlertDate) {
            riskReg.proximityAlertDate = new Date(riskReg.proximityAlertDate); //riskReg.proximityAlertDate? moment(new Date(riskReg.proximityAlertDate)).format("DD-MMM-YYYY"):null;
          }
          if (riskReg.updatedDate) {
            var time = moment(riskReg.updatedDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let updatedDate = time;
            riskReg.updatedDate = riskReg.updatedDate
              ? new Date(updatedDate)
              : "";
          }
          if (riskReg.createdDate) {
            let time = moment(riskReg.createdDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let createdDate = time;
            riskReg.createdDate = riskReg.createdDate
              ? new Date(createdDate)
              : "";
          }
          if (riskReg.closedDate) {
            let time = moment(riskReg.closedDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let closedDate = time;
            riskReg.closedDate = riskReg.closedDate ? new Date(closedDate) : "";
          }

          if (riskReg.isClosed === false) {
            riskReg.isClosed = "Open";
          } else {
            riskReg.isClosed = "Closed";
          }
          if (riskReg.isApproved === false) {
            riskReg.isApproved = "No";
          } else {
            riskReg.isApproved = "Yes";
          }
        });
        //CheckBox
        var taskData = [];
        if (!response.isFiltered) {
          taskData = response.taskActions.map((dataItem) =>
            Object.assign({ selected: true }, dataItem)
          );
        } else {
          taskData = response.taskActions.map((dataItem) =>
            Object.assign({ selected: false }, dataItem)
          );
        }
        this.setState({
          ...this.state,
          loader: false,
          taskActionDataList: taskData,
        });
      } else {
        this.setState({ ...this.state, loader: false, taskActionDataList: [] });
      }
    } catch (err) {
      this.setState({ ...this.state, loader: false, taskActionDataList: [] });
    }
  };
  getMatrixColorCodes = async () => {
    try {
      // var req = {
      //   WorkstreamId: 0,
      // };
      let response = await Api.MatrixColor();
      if (response.status === 200) {
        // normal,opportunity
        let normal_opp = response.matrixColor.find(
          (item) => item.riskType === "opportunity"
        );
        let opp_colorJsonData = JSON.parse(normal_opp.colorJsonData);

        //  normal,threat
        let normal_threat = response.matrixColor.find(
          (item) => item.riskType === "threat"
        );
        let threat_colorJsonData = JSON.parse(normal_threat.colorJsonData);
        this.setState({
          HeatMapConfigDataThreat: threat_colorJsonData,
          HeatMapConfigDataOpportunity: opp_colorJsonData,

          heatMapCount: response.heatmapCount,
          dynamicHeatmapProbabilityRange:
            response.dynamicHeatmapProbabilityRange,
        });
      }
    } catch (error) {
      console.error(error);
    }
  };
  getAllTenantUserList = async () => {
    try {
      let response = await Api.getuserAddedByTenant();
      if (response.status === 200 && response.tenantUsers) {
        var userList = [];
        for (var i = 0; i < response.tenantUsers.length; i++) {
          userList.push({
            value: response.tenantUsers[i].userId,
            name: response.tenantUsers[i].name,
          });
        }
        this.setState({ ...this.state, userList: userList });
      }
    } catch (error) {
      console.error(error);
    }
  };
  getFrozenRiskDataByViewId = async (viewData) => {
    try {
      var loggedClient = secureLocalStorage.getItem("loggedClient");
      var createdby =
        loggedClient == "user"
          ? secureLocalStorage.getItem("userId")
          : secureLocalStorage.getItem("tenantId");
      const requestParams = {
        id: viewData.dataSourceId,
        CreatedBy: parseInt(createdby),
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.getFrozenDataset(requestParams);
      if (response.status == 200 && response.datasetResponse) {
        var riskRegister = await this.toCamel(response.datasetResponse[0]);

        var selectedOrgUnitArray = [];
        riskRegister.map((riskReg) => {
          if (riskReg.proximityDate) {
            riskReg.proximityDate = new Date(riskReg.proximityDate);
          }
          if (riskReg.createdDate) {
            riskReg.createdDate = new Date(riskReg.createdDate);
          }
          selectedOrgUnitArray.push(riskReg.organizationUnitId);
        });
        let impactMaster = [];
        if (riskRegister && riskRegister.length > 0) {
          impactMaster = riskRegister[0].impactResponse;
        }
        this.setState({ ...this.state, impactMaster: impactMaster });
        await this.createDynamicCustomFields(riskRegister);
        await this.createDynamicCols(riskRegister);

        var riskData = riskRegister.map((dataItem) =>
          Object.assign({ selected: false }, dataItem)
        );

        this.setState({
          ...this.state,
          selectedOrgUnit: selectedOrgUnitArray,
          OrgUnitIds: Array.from(new Set(selectedOrgUnitArray)),
          riskList: riskData,
          riskTemp: riskData,
          loader: false,
        });
      } else {
        this.refs.child.refreshData([]);
        this.setState({
          ...this.state,
          riskList: [],
          selectedOrgUnit: [],
          riskTemp: [],
          loader: false,
        });
      }
    } catch (error) {
      this.setState({ ...this.state, loader: false });
    }
  };

  getFrozenActionDataByViewId = async (viewData) => {
    try {
      var loggedClient = secureLocalStorage.getItem("loggedClient");
      var createdby =
        loggedClient == "user"
          ? secureLocalStorage.getItem("userId")
          : secureLocalStorage.getItem("tenantId");
      const requestParams = {
        id: viewData.dataSourceId,
        CreatedBy: parseInt(createdby),
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.getFrozenDataset(requestParams);
      if (response.status == 200 && response.datasetResponse) {
        let riskMitigationResponse = await this.toCamel(
          response.datasetResponse[0]
        );

        riskMitigationResponse.map((riskReg) => {
          riskReg.createdDate = riskReg.createdDate
            ? new Date(riskReg.createdDate)
            : "";
          riskReg.actualCompletionDate = riskReg.actualCompletionDate
            ? new Date(riskReg.actualCompletionDate)
            : "";
          riskReg.projectedCompletionDate = riskReg.projectedCompletionDate
            ? new Date(riskReg.projectedCompletionDate)
            : "";
          riskReg.originalCompletionDate = riskReg.originalCompletionDate
            ? new Date(riskReg.originalCompletionDate)
            : "";
          riskReg.proximityDate = riskReg.proximityDate
            ? new Date(riskReg.proximityDate)
            : "";
        });
        this.setState({
          ...this.state,
          loader: false,
          mitigationData: riskMitigationResponse,
          OrgUnitIds: riskMitigationResponse.orgunitIds,
        });
      } else {
        this.setState({
          ...this.state,
          loader: false,
          mitigationData: [],
          OrgUnitIds: [],
        });
      }
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };

  toCamel = (o) => {
    var newO, origKey, newKey, value;
    if (o instanceof Array) {
      return o.map((value) => {
        if (typeof value === "object") {
          value = this.toCamel(value);
        }
        return value;
      });
    } else {
      newO = {};
      for (origKey in o) {
        if (o.hasOwnProperty(origKey)) {
          newKey = (
            origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey
          ).toString();
          value = o[origKey];
          if (
            value instanceof Array ||
            (value !== null && value.constructor === Object)
          ) {
            value = this.toCamel(value);
          }
          newO[newKey] = value;
        }
      }
    }
    return newO;
  };

  getRiskDataByViewId = async (viewData) => {
    try {
      var loggedClient = secureLocalStorage.getItem("loggedClient");
      var createdby =
        loggedClient == "user"
          ? secureLocalStorage.getItem("userId")
          : secureLocalStorage.getItem("tenantId");
      const requestParams = {
        ViewId: viewData.dataSourceId,
        CreatedBy: parseInt(createdby),
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.getByViewId(requestParams);
      if (response.status == 200) {
        var selectedOrgUnitArray = [];
        response.riskRegister.map((riskReg) => {
          if (riskReg.proximityDate) {
            riskReg.proximityDate = new Date(riskReg.proximityDate);
          } else {
            riskReg.proximityDate = null;
          }
          if (riskReg.updatedDate) {
            var time = moment(riskReg.updatedDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let updatedDate = time;
            riskReg.updatedDate = riskReg.updatedDate
              ? new Date(updatedDate)
              : "";
          } else {
            riskReg.updatedDate = null;
          }
          if (riskReg.createdDate) {
            var time = moment(riskReg.createdDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let createdDate = time;
            riskReg.createdDate = riskReg.createdDate
              ? new Date(createdDate)
              : "";
          } else {
            riskReg.createdDate = null;
          }

          selectedOrgUnitArray.push(riskReg.organizationUnitId);
          // if (riskReg.riskTypeNames && riskReg.riskTypeNames.length > 0) {
          //   let hashArr = this.stringToHash(
          //     riskReg.riskTypeNames.toString(),
          //     "riskTypeNames"
          //   );

          //   riskReg["riskTypeNames"] = hashArr;
          // } else {
          //   riskReg["riskTypeNames"] = "undefined";
          // }
          if (riskReg.isClosed) {
            riskReg.isClosed = "Open";
          } else {
            riskReg.isClosed = "Closed";
          }
          if (riskReg.closedDate) {
            riskReg.closedDate = new Date(riskReg.closedDate);
          } else {
            riskReg.closedDate = null;
          }
        });
        let impactMaster = [];
        if (response.riskRegister && response.riskRegister.length > 0) {
          impactMaster = response.riskRegister[0].impactResponse;
        }

        this.setState({ ...this.state, impactMaster: impactMaster });
        await this.createDynamicCustomFields(response.riskRegister);
        await this.createDynamicCols(response.riskRegister);

        var riskData = response.riskRegister.map((dataItem) =>
          Object.assign({ selected: false }, dataItem)
        );

        this.setState({
          ...this.state,
          selectedOrgUnit: selectedOrgUnitArray,
          OrgUnitIds: Array.from(new Set(selectedOrgUnitArray)),
          riskList: riskData,
          riskTemp: riskData,
          loader: false,
        });
      } else {
        this.refs.child.refreshData([]);
        this.setState({
          ...this.state,
          riskList: [],
          selectedOrgUnit: [],
          riskTemp: [],
          loader: false,
        });
      }
    } catch (error) {
      this.setState({ ...this.state, loader: false });
    }
  };
  getActionTypeList = async () => {
    try {
      let response = await Api.getProjectStage();
      if (response.status === 200 && response.actionTypes) {
        var tempActionTypeList = [];
        for (var i = 0; i < response.actionTypes.length; i++) {
          tempActionTypeList.push({
            value: response.actionTypes[i].actionId,
            name: response.actionTypes[i].name,
          });
        }
        let newFirstElement = {
          value: null,
          name: " [blank]",
        };
        tempActionTypeList = [newFirstElement].concat(tempActionTypeList);
        this.setState({ ...this.state, actionTypeList: tempActionTypeList });
      }
    } catch (error) {
      console.error(error);
    }
  };
  getActionDataByViewId = async (viewData) => {
    try {
      var loggedClient = secureLocalStorage.getItem("loggedClient");
      var createdby =
        loggedClient == "user"
          ? secureLocalStorage.getItem("userId")
          : secureLocalStorage.getItem("tenantId");
      const requestParams = {
        ViewId: viewData.dataSourceId,
        CreatedBy: parseInt(createdby),
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.getMitigationFromView(requestParams);
      if (response.status == 200) {
        response.riskMitigationResponse.map((riskReg) => {
          riskReg.createdDate = riskReg.createdDate
            ? new Date(riskReg.createdDate)
            : "";
          riskReg.actualCompletionDate = riskReg.actualCompletionDate
            ? new Date(riskReg.actualCompletionDate)
            : "";
          riskReg.projectedCompletionDate = riskReg.projectedCompletionDate
            ? new Date(riskReg.projectedCompletionDate)
            : "";
          riskReg.originalCompletionDate = riskReg.originalCompletionDate
            ? new Date(riskReg.originalCompletionDate)
            : "";
          riskReg.proximityDate = riskReg.proximityDate
            ? new Date(riskReg.proximityDate)
            : "";
          if (riskReg.isClosed) {
            riskReg.isClosed = "Open";
          } else {
            riskReg.isClosed = "Closed";
          }
          riskReg["isOpen"]=riskReg.isOpen?"Open":"Closed";
          riskReg["approved"]=riskReg.approved?"Yes":"No";
          if (riskReg.closedDate) {
            riskReg.closedDate = new Date(riskReg.closedDate);
          } else {
            riskReg.closedDate = null;
          }
        });
        this.setState({
          ...this.state,
          loader: false,
          mitigationData: response.riskMitigationResponse,
          mitigationDataTemp: response.riskMitigationResponse,
          OrgUnitIds: response.orgunitIds,
        });
      } else {
        this.setState({
          ...this.state,
          loader: false,
          mitigationData: [],
          OrgUnitIds: [],
        });
      }
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };
  createDynamicCustomFields = async (products, filter) => {
    try {
      let dropdownColumn = [];
      products.map((res, i) => {
        res.customFields.map((item, j) => {
          if (dropdownColumn.length > 0) {
            if (!dropdownColumn.find((cf) => cf.fieldName === item.fieldName)) {
              dropdownColumn.push({
                fieldName: item.fieldName,
                data: this.getCustomFieldMasterData(item.fieldName, filter),
                inputType: this.getInputType(item.fieldName),
              });
            }
          } else {
            dropdownColumn.push({
              fieldName: item.fieldName,
              data: this.getCustomFieldMasterData(item.fieldName, filter),
              inputType: this.getInputType(item.fieldName),
            });
          }
        });
      });

      if (dropdownColumn.length > 0) {
        products.map((res) => {
          dropdownColumn.map((col) => {
            let temp = res.customFields.find(
              (item) => item.fieldName === col.fieldName
            );
            if (temp) {
              if (temp.inputType === "Multi Drop Down") {
                let val = temp.selectedCustomFieldNames
                  ? temp.selectedCustomFieldNames.toString()
                  : "";
                let hashArr = this.stringToHashForCF(val, col.data);
                res[col.fieldName] = hashArr;
              } else if (temp.inputType === "Single Drop Down") {
                let val =
                  temp.selectedCustomFieldNames &&
                  temp.selectedCustomFieldNames.length > 0
                    ? temp.selectedCustomFieldNames.toString()
                    : null;
                res[col.fieldName] = val;
              } else if (temp.inputType === "Free Text") {
                let val =
                  temp.multiText && temp.multiText != ""
                    ? temp.multiText
                    : null;
                res[col.fieldName] = val;
              } else if (temp.inputType === "Numeric") {
                let val =
                  temp.multiText && temp.multiText != ""
                    ? parseInt(temp.multiText)
                    : null;
                res[col.fieldName] = val;
              } else if (temp.inputType === "Date") {
                let val =
                  temp.multiText && temp.multiText != ""
                    ? new Date(temp.multiText)
                    : null;
                res[col.fieldName] = val;
              }
            } else {
              res[col.fieldName] = "";
            }
          });
        });
      }
      let columnsToShow = [];
      if (dropdownColumn.length > 0) {
        columnsToShow = dropdownColumn.map((item) => (
          <Column
            field={item.fieldName}
            title={item.fieldName}
            width="150px"
            cell={(props) =>
              this.viewMultiselectColsCustomDropdown(props, item)
            }
            columnMenu={(props) => this.getCustomFieldColumnMenu(props, item)}
            filter={this.getCustomFieldFilter(item)}
            headerClassName={this.checkItsinFilterOrNot(item.fieldName, filter)}
          />
        ));
      }
      this.setState({ ...this.state, dropdownColumns: columnsToShow });
    } catch (err) {
      console.log(err);
    }
  };
  getCustomFieldFilter = (item) => {
    if (item.inputType === "Multi Drop Down") {
      return "";
    } else if (item.inputType === "Single Drop Down") {
      return "text";
    } else if (item.inputType === "Free Text") {
      return "";
    } else if (item.inputType === "Numeric") {
      return "numeric";
    } else if (item.inputType === "Date") {
      return "date";
    } else {
      return "";
    }
  };

  clearFilter = async (e) => {
    try {
      let filter = e ? e : [];
      const result = filterBy(this.state.riskTemp, filter);
      await this.createDynamicCustomFields(result, filter);
      await this.createDynamicCols(result, filter);
      await this.checkRisktypeSelections(filter);
      this.setState({
        ...this.state,
        riskList: result,
        existingFilter: filter,
        take: Math.round((window.innerHeight - 250) / 35),
        skip: 0,
        sort: [],
        filter: {
          logic: "and",
          filters: filter,
        },
      });
    } catch (err) {
      console.error(err);
    }
  };
  getcustomfieldlist = (list) => {
    var sorted_arr = list.sort(function (a, b) {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });
    return sorted_arr;
  };
  getCustomFieldColumnMenu = (props, item) => {
    if (item.inputType === "Multi Drop Down") {
      this.getcustomfieldlist(item.data);
      return (
        <CustomFieldSearchMenu
          {...props}
          customFieldsmaster={item.data}
          existingFilter={this.state.existingFilter}
          filterChangeV={this.filterChangeV}
          clearFilter={this.clearFilter}
        />
      );
    } else if (item.inputType === "Single Drop Down") {
      return (
        <SingleDropDownCheckboxFilter
          {...props}
          filterData={item.data}
          existingFilter={this.state.existingFilter}
          filterChangeV={this.filterChangeV}
          clearFilter={this.clearFilter}
        />
      );
    } else {
      return (
        <ColumnMenuFilter
          {...props}
          getSelectedColumn={this.getSelectedColumn}
        />
      );
    }
  };
  filterChangeV = async (e, colname) => {
    let exi = [];
    if (this.state.existingFilter) {
      let filterData = this.state.existingFilter;
      filterData.map((filter2) => {
        if (filter2.filters) {
          filter2.filters.map((innerFilter) => {
            if (innerFilter.field !== colname) {
              exi.push(filter2);
            }
          });
        } else {
          if (filter2.field !== colname) {
            exi.push(filter2);
          }
        }
      });
    }

    let filter = e ? e.filters : [];
    let temp = [];
    if (filter.length > 0) {
      temp = [
        {
          filters: filter,
          logic: "or",
        },
      ];
    }

    let arr = [...exi, ...temp];

    const result = filterBy(this.state.riskTemp, arr);
    if (result && result.length > 0) {
      await this.createDynamicCustomFields(result, arr);
      await this.createDynamicCols(result, arr);
      await this.checkRisktypeSelections(arr);
    }
    this.setState({
      ...this.state,
      riskList: result,
      existingFilter: arr,
      take: Math.round((window.innerHeight - 250) / 35),
      skip: 0,
      filter: {
        logic: "and",
        filters: arr,
      },
    });
  };
  getSelectedColumn = (col) => {
    console.log("col", col);
    console.log("this.state.selectedColumn", this.state.selectedColumn);

    if (col !== this.state.selectedColumn) {
      this.setState({ ...this.state, selectedColumn: col });
      console.log("getSelectedColumn", this.state.selectedColumn);
    }
  };
  setClassName = (field) => {
    let headerClassName = "";
    if (this.state.filter) {
      console.log("this.state.filter", this.state.filter);

      this.state.filter.filters.map((e) => {
        if (e.field === field) {
          headerClassName = "active";
        }
        if (e.filters) {
          e.filters.map((innerFilter) => {
            if (innerFilter.field === field) {
              headerClassName = "active";
            }
          });
        }
      });
    }
    return headerClassName;
  };
  checkItsinFilterOrNot = (field, exfilter) => {
    try {
      let headerClassName = "";
      if (exfilter) {
        exfilter.map((filter) => {
          if (filter.field === field) {
            headerClassName = "active";
          }
          if (filter.filters) {
            filter.filters.map((innerFilter) => {
              if (innerFilter.field === field) {
                headerClassName = "active";
              }
            });
          }
        });
        return headerClassName;
      }
    } catch (err) {}
  };
  getInputType = (fieldName) => {
    try {
      let arr = this.state.customFieldsmaster.find(
        (item) => item.fieldName == fieldName
      );
      if (arr) {
        return arr.inputType;
      } else {
        return undefined;
      }
    } catch (err) {
      console.log(err);
    }
  };

  getCustomField = async () => {
    let res = [];
    try {
      var request = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      };

      let response = await Api.getCustomField(request);
      if (response.status === 200) {
        response.customFields.map((item) => {
          item.cfPossibleValues.map((item1) => {
            item1["hashValue"] = this.convertStrToHash(item1.possibleValues);
          });
          // if (item.inputType == "Multi Drop Down") {
          //   let newFirstElement = {
          //     hashValue: "",
          //     id: 0,
          //     possibleValues: " [blank]",
          //   };

          //   item["cfPossibleValues"] = [newFirstElement].concat(
          //     item.cfPossibleValues
          //   );
          //   item["possibleValues"] = [" [blank]"].concat(item.possibleValues);
          // }
          // else if(item.inputType=="Single Drop Down"){
          //   let newFirstElement = {
          //     "hashValue":null,
          //     "id": 0,
          //     "possibleValues": " [blank]",
          //   }
          //   item["cfPossibleValues"] = [newFirstElement].concat(item.cfPossibleValues);
          //   item["possibleValues"]=[" [blank]"].concat(item.possibleValues);
          // }
        });

        this.setState({
          ...this.state,
          customFieldsmaster: [...response.customFields],
        });
      } else {
        this.setState({
          ...this.state,
          customFieldsmaster: [],
        });
      }
    } catch (err) {
      console.error("Exception:", err);
      this.setState({
        ...this.state,
        customFieldsmaster: [],
      });
    }
    return res;
  };

  convertStrToHash = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      let char = str.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash = hash & hash;
    }
    hash = Math.abs(hash).toString();
    return hash;
  };

  stringToHashForCF(stringArr, data) {
    let hashArr = [];
    if (stringArr && stringArr.includes(",")) {
      let valArr = stringArr.split(",");
      valArr &&
        valArr.map((item1) => {
          let cfVal = data.find((item) => item.name === item1);
          if (cfVal) {
            hashArr.push(cfVal.hashValue);
          }
        });
    } else {
      let cfVal = data.find((item) => item.name === stringArr);
      if (cfVal) {
        hashArr.push(cfVal.hashValue);
      }
    }
    return hashArr.toString();
  }

  viewMultiselectColsCustomDropdown = (event, cfObj) => {
    let data = cfObj.data;
    let value = event.dataItem[event.field];

    if (cfObj && cfObj.inputType === "Multi Drop Down") {
      let temp = [];
      if (value && value.includes(",")) {
        let arr = value.split(",");
        arr &&
          arr.map((item1, i) => {
            let originalValue = data.find((item) => item.hashValue === item1);
            if (originalValue) {
              temp.push(originalValue.name);
            }
          });
      } else {
        let originalValue = data.find((item) => item.hashValue === value);
        if (originalValue) {
          temp.push(originalValue.name);
        }
      }
      return <td title={temp.toString()}>{temp.toString()}</td>;
    } else if (cfObj && cfObj.inputType === "Single Drop Down") {
      return (
        <td title={value ? value.toString() : ""}>
          {value ? value.toString() : ""}
        </td>
      );
    } else if (cfObj && cfObj.inputType === "Free Text") {
      return (
        <td title={value ? value.toString() : ""}>
          {value ? value.toString() : ""}
        </td>
      );
    } else if (cfObj && cfObj.inputType === "Numeric") {
      return (
        <td
          title={
            value || value === 0 ? formatNumber(parseInt(value), "##,#") : ""
          }
        >
          {value || value === 0 ? formatNumber(parseInt(value), "##,#") : ""}
        </td>
      );
    } else if (cfObj && cfObj.inputType === "Date") {
      return (
        <td title={value ? moment(value).format("DD-MMM-YYYY") : ""}>
          {value ? moment(value).format("DD-MMM-YYYY") : ""}
        </td>
      );
    } else {
      return <td></td>;
    }
  };

  getCustomFieldMasterData = (fieldName, filter) => {
    try {
      let arr = this.state.customFieldsmaster.find(
        (item) => item.fieldName === fieldName
      );
      if (arr) {
        let temp = [];
        arr.cfPossibleValues.map((item, index) => {
          let checked = this.checkCFinFilterValuesOrNot(
            fieldName,
            item.hashValue,
            filter
          );
          temp.push({
            id: index,
            name: item.possibleValues,
            checked: checked,
            hashValue: item.hashValue, //this.convertStrToHash(item),
          });
        });
        return temp;
      } else {
        return [];
      }
    } catch (err) {
      return [];
    }
  };

  getRiskTypeList = async () => {
    var typeList = [];
    try {
      let response = await Api.getRiskType();
      if (response.status === 200 && response.riskTypes) {
        for (var i = 0; i < response.riskTypes.length; i++) {
          if (response.riskTypes[i].name && response.riskTypes[i].name !== "") {
            typeList.push({
              id: response.riskTypes[i].riskTypeId,
              name: response.riskTypes[i].name,
              checked: false,
              hashValue: this.convertStrToHash(response.riskTypes[i].name),
            });
          }
        }

        this.setState({
          ...this.state,
          riskTypemaster: [...typeList],
        });
      }
    } catch (error) {
      console.error(error);
    }
  };
  getCustomField = async () => {
    let res = [];
    try {
      var request = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      };

      let response = await Api.getCustomField(request);
      if (response.status === 200) {
        response.customFields.map((item) => {
          item.cfPossibleValues.map((item1) => {
            item1["hashValue"] = this.convertStrToHash(item1.possibleValues);
            return item1;
          });
          // if (item.inputType == "Multi Drop Down") {
          //   let newFirstElement = {
          //     hashValue: "",
          //     id: 0,
          //     possibleValues: " [blank]",
          //   };
          //   item["cfPossibleValues"] = [newFirstElement].concat(
          //     item.cfPossibleValues
          //   );
          //   item["possibleValues"] = [" [blank]"].concat(item.possibleValues);
          // }
          return item;
        });

        this.setState({
          ...this.state,
          customFieldsmaster: [...response.customFields],
        });
      }
    } catch (err) {
      console.error("Exception:", err);
    }
    return res;
  };

  mitigationFilterQuery = (query) => {
    this.setState({
      ...this.state,
      mitigationFilter: query,
    });
  };
  getSelectedIds = (ids) => {
    this.setState({
      ...this.state,
      selectedActionIds: ids,
    });
  };
  createAppState = (dataState) => {
    if (this.state && this.state.riskTemp) {
      return {
        riskList: this.state.riskTemp.slice(0),
        dataState: dataState,
      };
    } else {
      return {
        riskList: [],
        dataState: dataState,
      };
    }
  };

  dataStateChange = (event) => {
    this.setState(this.createAppState(event.dataState));
  };

  expandChange(event) {
    event.dataItem.expanded = event.value;
    let riskRegisterId = event.dataItem.riskRegisterId;
    this.setState({ ...this.state });
    if (!event.value || event.dataItem.mitigationResps) {
      return;
    }
    let data = this.state.riskList.slice();
    let index = data.findIndex((d) => d.riskRegisterId === riskRegisterId);
    data[index].mitigationResps = this.state.riskList.filter(
      (d) => d.riskRegisterId === riskRegisterId
    );
    this.setState({ riskList: data });
  }

  selectionChange = (event) => {
    const data = this.state.riskList.map((item) => {
      if (item.riskRegisterId === event.dataItem.riskRegisterId) {
        item.selected = !event.dataItem.selected;
      }
      return item;
    });
    this.saveSelectedIds(data);
    this.setState({ data });
    this.setState({
      ...this.state,
      mitigatedHistogramResponse: {},
      nonMitigatedMonteCarloResponse: {},
      mitigatedTornodoResponse: [],
      nonmitigatedTornodoResponse: [],
      mitigatedTornodoResponseOpportunity: {},
      mitigatedHistogramResponseOpportunity: {},
      nonmitigatedTornodoResponseOpportunity: [],
      nonmitigatedHistogramResponseOpportunity: [],
      nonMitigatedFullTornodoResponses: [],
      mitigatedFullTornodoResponses: [],
      nonMitigatedOppFullTornodoResponses: [],
      mitigatedOppFullTornodoResponses: [],
    });
  };
  filterChangeExisting = async (e) => {
    try {
      if (e.nativeEvent.type === "submit") {
        try {
          let existingFilter = this.state.existingFilter
            ? this.state.existingFilter
            : [];
          let filter = e.filter ? e.filter.filters : [];

          // Get the field being filtered from the new filter
          const newFilterFields = new Set();
          if (filter && filter.length > 0) {
            filter.forEach(filterItem => {
              if (filterItem.filters) {
                filterItem.filters.forEach(innerFilter => {
                  if (innerFilter.field) {
                    newFilterFields.add(innerFilter.field);
                  }
                });
              } else if (filterItem.field) {
                newFilterFields.add(filterItem.field);
              }
            });
          }

          // Remove any existing filters for the same fields
          let filteredExisting = existingFilter.filter(item => {
            // For filters with nested filters array
            if (item.filters) {
              return !item.filters.some(innerFilter =>
                innerFilter.field && newFilterFields.has(innerFilter.field)
              );
            }
            // For direct filters
            return !(item.field && newFilterFields.has(item.field));
          });

          // Combine filtered existing filters with new filters
          let combinedFilters = [...filteredExisting, ...filter];

          // Deduplicate the combined filters
          const uniqueFilters = new Set();
          const dedupedFilters = [];

          for (const filterItem of combinedFilters) {
            const filterStr = JSON.stringify(filterItem);
            if (!uniqueFilters.has(filterStr)) {
              uniqueFilters.add(filterStr);
              dedupedFilters.push(filterItem);
            }
          }
          const result = filterBy(this.state.riskTemp, dedupedFilters);
          if (result && result.length > 0) {
            await this.createDynamicCustomFields(result, dedupedFilters);
            await this.createDynamicCols(result, dedupedFilters);
            await this.checkRisktypeSelections(dedupedFilters);
            this.setState({
              ...this.state,
              riskList: result,
              existingFilter: dedupedFilters,
              take: Math.round((window.innerHeight - 250) / 35),
              skip: 0,
              sort: [],
              filter: {
                logic: "and",
                filters: dedupedFilters,
              },
            });
          } else {
            this.setState({
              ...this.state,
              riskList: result,
              existingFilter: dedupedFilters,
              take: Math.round((window.innerHeight - 250) / 35),
              skip: 0,
              sort: [],
              filter: {
                logic: "and",
                filters: dedupedFilters,
              },
              dropdownColumns: this.state.dropdownColumns,
            });
          }
        } catch (err) {
          console.log(err);
        }
      } else if (e.nativeEvent.type === "reset") {
        try {
          let exi = [];
          if (this.state.existingFilter) {
            let filterData = this.state.existingFilter;
            filterData.forEach((filter2) => {
              if (filter2.filters) {
                // Only add the filter if none of its inner filters match the selected column
                const hasMatchingInnerFilter = filter2.filters.some(
                  innerFilter => innerFilter.field === this.state.selectedColumn
                );
                if (!hasMatchingInnerFilter) {
                  exi.push(filter2);
                }
              } else {
                if (filter2.field !== this.state.selectedColumn) {
                  exi.push(filter2);
                }
              }
            });
          }
          const result = filterBy(this.state.riskTemp, exi);
          await this.createDynamicCustomFields(result, exi);
          await this.createDynamicCols(result, exi);
          await this.checkRisktypeSelections(exi);
          this.setState(
            {
              ...this.state,
              riskList: result,
              existingFilter: exi,
              take: Math.round((window.innerHeight - 250) / 35),
              skip: 0,
              sort: [],
              filter: {
                logic: "and",
                filters: exi,
              },
            },
            console.log(result.length)
          );
        } catch (err) {
          console.log(err);
        }
      }
    } catch (err) {
      console.error(err);
    }
  };
  createDynamicCustomFields = async (products, filter) => {
    try {
      let dropdownColumn = [];
      products.map((res, i) => {
        res.customFields.map((item, j) => {
          if (dropdownColumn.length > 0) {
            if (!dropdownColumn.find((cf) => cf.fieldName === item.fieldName)) {
              dropdownColumn.push({
                fieldName: item.fieldName,
                data: this.getCustomFieldMasterData(item.fieldName, filter),
                inputType: this.getInputType(item.fieldName),
              });
            }
          } else {
            dropdownColumn.push({
              fieldName: item.fieldName,
              data: this.getCustomFieldMasterData(item.fieldName, filter),
              inputType: this.getInputType(item.fieldName),
            });
          }
        });
      });

      if (dropdownColumn.length > 0) {
        products.map((res) => {
          dropdownColumn.map((col) => {
            let temp = res.customFields.find(
              (item) => item.fieldName === col.fieldName
            );
            if (temp) {
              if (temp.inputType === "Multi Drop Down") {
                let val = temp.selectedCustomFieldNames
                  ? temp.selectedCustomFieldNames.toString()
                  : "";
                let hashArr = this.stringToHashForCF(val, col.data);
                res[col.fieldName] = hashArr;
              } else if (temp.inputType === "Single Drop Down") {
                let val =
                  temp.selectedCustomFieldNames &&
                  temp.selectedCustomFieldNames.length > 0
                    ? temp.selectedCustomFieldNames.toString()
                    : null;
                res[col.fieldName] = val;
              } else if (temp.inputType === "Free Text") {
                let val =
                  temp.multiText && temp.multiText != ""
                    ? temp.multiText
                    : null;
                res[col.fieldName] = val;
              } else if (temp.inputType === "Numeric") {
                let val =
                  temp.multiText && temp.multiText != ""
                    ? parseInt(temp.multiText)
                    : null;
                res[col.fieldName] = val;
              } else if (temp.inputType === "Date") {
                let val =
                  temp.multiText && temp.multiText != ""
                    ? new Date(temp.multiText)
                    : null;
                res[col.fieldName] = val;
              }
            } else {
              res[col.fieldName] = "";
            }
          });
        });
      }
      let columnsToShow = [];
      if (dropdownColumn.length > 0) {
        columnsToShow = dropdownColumn.map((item) => (
          <Column
            field={item.fieldName}
            title={item.fieldName}
            width="150px"
            cell={(props) =>
              this.viewMultiselectColsCustomDropdown(props, item)
            }
            columnMenu={(props) => this.getCustomFieldColumnMenu(props, item)}
            filter={this.getCustomFieldFilter(item)}
            headerClassName={this.checkItsinFilterOrNot(item.fieldName, filter)}
          />
        ));
      }
      this.setState({ ...this.state, dropdownColumns: columnsToShow });
    } catch (err) {
      console.log(err);
    }
  };
  //Impact
  createDynamicCols = async (products) => {
    let impactColumn = [];

    products.map((res, i) => {
      if (res.impactResponse) {
        res.impactResponse.map((item, j) => {
          if (impactColumn.length > 0) {
            if (!impactColumn.includes(item.name + "_" + item.type)) {
              impactColumn.push(item.name + "_" + item.type);
            }
          } else {
            impactColumn.push(item.name + "_" + item.type);
          }
        });
      }
    });
    // impactColumn.sort();
    // impactColumn.reverse();
    if (impactColumn.length > 0) {
      products.map((res) => {
        impactColumn.map((col) => {
          let temp = res.impactResponse.filter(
            (item) => item.name + "_" + item.type === col
          );
          if (temp.length > 0) {
            res[col] =
              temp[0].type == "Post" ? temp[0].postImpactValue : temp[0].value;
          } else {
            res[col] = undefined;
          }
        });
      });
    }

    let columnsToShow = [];
    if (impactColumn.length > 0) {
      columnsToShow = impactColumn.map((item) => (
        <Column
          field={item}
          title={this.getImpactUnit(item)}
          width="100px"
          editable={false}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          cell={(props) => (
            <ImpactEditComponent {...props} onEditCell={this.onEditCell} />
          )}
          filter={"numeric"}
        />
      ));
    }
    this.setState({ ...this.state, impactColumns: columnsToShow });
  };
  getImpactUnit = (impact) => {
    var impactTemp = this.state.impactMaster.find(
      (item) => item.name + "_" + item.type === impact
    );
    var res = impact;
    if (impactTemp && impactTemp.name) {
      let unit = impactTemp.units ? impactTemp.units : "";
      res = impactTemp.name + " / " + unit + " (" + impactTemp.type + ")";
    }
    return res;
  };
  getImpactCellComponent = (props, impact) => {
    if (impact.impactType == "Qualitative") {
      return (
        <QualitativeImpactEditComponent
          {...props}
          onEditCell={this.onEditCell}
        />
      );
    } else {
      return <ImpactEditComponent {...props} onEditCell={this.onEditCell} />;
    }
  };
  checkCFinFilterValuesOrNot = (field, value, exfilter) => {
    let flag = false;
    try {
      if (exfilter) {
        exfilter.map((filter) => {
          if (filter.field === field && filter.value == value) {
            flag = true;
          }
          if (filter.filters) {
            filter.filters.map((innerFilter) => {
              if (innerFilter.field === field && innerFilter.value == value) {
                flag = true;
              }
            });
          }
        });
      }
    } catch (err) {
      return flag;
    }
    return flag;
  };
  checkRisktypeSelections = (exfilter) => {
    let temp = [];
    this.state.riskTypemaster.map((item) => {
      let checked = this.checkCFinFilterValuesOrNot(
        "riskTypeNames",
        item.hashValue,
        exfilter
      );
      item["checked"] = checked;
      temp.push(item);
    });
    this.setState({ ...this.state, riskTypemaster: temp });
  };
  saveSelectedIds = (data) => {
    console.log("data", data);
    var listOfIds = [];
    for (let row of Object.values(data)) {
      if (row.selected) {
        listOfIds.push(row.riskRegisterId);
      }
    }
    //State is not updated here while clicking check box
    this.state = { selectedIds: listOfIds };
    this.setState({ ...this.state, selectedIds: listOfIds }, () => {
      console.log("selectedIds", this.state.selectedIds);
    });
  };
  onEditCell() {}
  render() {
    let isPrime =
      this.props.chartData.isPrimeWorkstreams == false ||
      secureLocalStorage.getItem("isPrime") === false
        ? false
        : true;
    return (
      <div>
        {this.state.loader ? (
          <span className="MatTableSpinner">
            <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
          </span>
        ) : null}
        {!this.props.chartData.isActionWidget &&
          this.props.chartData.reportType !== "Task" &&
          this.props.chartData.reportType !== "TaskAction" && (
            <div id="reportrisk">
              <div
                className="tblCont riskRegister dataGrids reportsGrid"
                id="rw-tab-header"
              >
                <Grid
                  style={{ minHeight: "100px" }}
                  data={process(this.state.riskList, this.state.dataState)}
                  reorderable
                  resizable
                  expandField="expanded"
                  selectedField="selected"
                  onExpandChange={this.expandChange}
                  detail={MitigationDetails}
                  {...this.state.dataState}
                  onDataStateChange={this.dataStateChange}
                  sortable={true}
                  pageable={true}
                  onFilterChange={this.filterChangeExisting}
                  filter={this.state.filter}
                >
                  {/* <GridNoRecords>Associated Dataset's Impact/Custom fields might been deleted or revoked</GridNoRecords> */}
                  <Column
                    field="organizationUnitName"
                    title="Workstream"
                    width="100px"
                    editable={false}
                    columnMenu={(props) => (
                      <ColumnMenuFilter
                        {...props}
                        getSelectedColumn={this.getSelectedColumn}
                      />
                    )}
                    headerClassName={this.setClassName("organizationUnitName")}
                  />
                  <Column
                    locked={true}
                    field="number"
                    title="Risk Number"
                    width="100px"
                    columnMenu={(props) => (
                      <ColumnMenuFilter
                        {...props}
                        getSelectedColumn={this.getSelectedColumn}
                      />
                    )}
                    headerClassName={this.setClassName("number")}
                  />
                  <Column
                    field="riskTitle"
                    title="Risk Title*"
                    width="150px"
                    locked={true}
                    columnMenu={(props) => (
                      <ColumnMenuFilter
                        {...props}
                        getSelectedColumn={this.getSelectedColumn}
                      />
                    )}
                    headerClassName={this.setClassName("riskTitle")}
                  />
                  <Column
                    field="isOpportunity"
                    title="T/O"
                    width="100px"
                    // columnMenu={ColumnMenu}
                    cell={(props) =>
                      props.dataItem.isOpportunity === "Threat" ? (
                        <td>{props.dataItem.isOpportunity}</td>
                      ) : (
                        <td>
                          <span className="turquoiseBlue">
                            {props.dataItem.isOpportunity}
                          </span>
                        </td>
                      )
                    }
                    columnMenu={(props) => (
                      <ColumnMenuCheckboxFilter
                        {...props}
                        data={this.state.riskList}
                        getSelectedColumn={this.getSelectedColumn}
                      />
                    )}
                    headerClassName={this.setClassName("isOpportunity")}
                  />
                  <Column
                    field="name"
                    title="Risk"
                    width="80px"
                    editable={false}
                    cell={(props) => (
                      <RiskDescriptionCell
                        {...props}
                        onEditCell={this.onEditCell}
                      />
                    )}
                    columnMenu={(props) => (
                      <ColumnMenuFilter
                        {...props}
                        getSelectedColumn={this.getSelectedColumn}
                      />
                    )}
                    headerClassName={this.setClassName("name")}
                  />

                  <Column
                    field="riskTypeNames"
                    title="Risk Type"
                    width="150px"
                    columnMenu={(props) => (
                      <SearchMenu
                        {...props}
                        existingFilter={this.state.existingFilter}
                        data={this.state.riskTypemaster}
                        filterChangeV={this.filterChangeV}
                        clearFilter={this.clearFilter}
                      />
                    )}
                    headerClassName={this.setClassName("riskTypeNames")}
                  />
                  <Column
                    field="mitigationCount"
                    title="Action Count"
                    width="80px"
                    filter={"numeric"}
                    columnMenu={(props) => (
                      <ColumnMenuFilter
                        {...props}
                        getSelectedColumn={this.getSelectedColumn}
                      />
                    )}
                    headerClassName={this.setClassName("mitigationCount")}
                  />
                  {this.state.dropdownColumns}
                  <Column
                    field="cause"
                    title="Cause"
                    width="100px"
                    editable={false}
                    cell={(props) => (
                      <RiskCauseCell {...props} onEditCell={this.onEditCell} />
                    )}
                    columnMenu={(props) => (
                      <ColumnMenuFilter
                        {...props}
                        getSelectedColumn={this.getSelectedColumn}
                      />
                    )}
                    headerClassName={this.setClassName("cause")}
                  />
                  <Column
                    field="existingControl"
                    title="Existing Control"
                    width="100px"
                    editable={false}
                    cell={(props) => (
                      <ExistingControlCell
                        {...props}
                        onEditCell={this.onEditCell}
                      />
                    )}
                    columnMenu={(props) => (
                      <ColumnMenuFilter
                        {...props}
                        getSelectedColumn={this.getSelectedColumn}
                      />
                    )}
                    headerClassName={this.setClassName("existingControl")}
                  />
                  <Column
                    field="frequency"
                    title="Pre-Probability (%)"
                    width="80px"
                    filter={"numeric"}
                    columnMenu={(props) => (
                      <ColumnMenuFilter
                        {...props}
                        getSelectedColumn={this.getSelectedColumn}
                      />
                    )}
                    headerClassName={this.setClassName("frequency")}
                  />
                  <Column
                    field="currentProbability"
                    title="Current Probability (%)"
                    width="80px"
                    editable={false}
                    cell={(props) => (
                      <td>
                        <span className="turquoiseBlue">
                          {props.dataItem.currentProbability}
                        </span>
                      </td>
                    )}
                    columnMenu={(props) => (
                      <ColumnMenuFilter
                        {...props}
                        getSelectedColumn={this.getSelectedColumn}
                      />
                    )}
                    headerClassName={this.setClassName("currentProbability")}
                  />
                  <Column
                    field="reductionProbability"
                    title="Post-Probability (%)"
                    width="75px"
                    editable={false}
                    cell={(props) => (
                      <td>
                        <span className="yellowCell">
                          {props.dataItem.reductionProbability}
                        </span>
                      </td>
                    )}
                    filter={"numeric"}
                    columnMenu={(props) => (
                      <ColumnMenuFilter
                        {...props}
                        getSelectedColumn={this.getSelectedColumn}
                      />
                    )}
                    headerClassName={this.setClassName("reductionProbability")}
                  />

                  <Column
                    field="pre"
                    title="pre"
                    width="75px"
                    sortable={false}
                    editable={false}
                    cell={(props) => (
                      <PrePostComponenant
                        {...props}
                        onEditCell={this.onEditCell}
                        HeatMapConfigDataOpportunity={
                          this.state.HeatMapConfigDataOpportunity
                        }
                        HeatMapConfigDataThreat={
                          this.state.HeatMapConfigDataThreat
                        }
                        dynamicHeatmapProbabilityRange={
                          this.state.dynamicHeatmapProbabilityRange
                        }
                      />
                    )}
                  />
                  <Column
                    field="current"
                    title="Current"
                    width="75px"
                    editable={false}
                    sortable={false}
                    cell={(props) => (
                      <PrePostComponenant
                        {...props}
                        onEditCell={this.onEditCell}
                        HeatMapConfigDataOpportunity={
                          this.state.HeatMapConfigDataOpportunity
                        }
                        HeatMapConfigDataThreat={
                          this.state.HeatMapConfigDataThreat
                        }
                        dynamicHeatmapProbabilityRange={
                          this.state.dynamicHeatmapProbabilityRange
                        }
                      />
                    )}
                  />
                  <Column
                    field="post"
                    title="post"
                    sortable={false}
                    width="75px"
                    editable={false}
                    cell={(props) => (
                      <PrePostComponenant
                        {...props}
                        onEditCell={this.onEditCell}
                        HeatMapConfigDataOpportunity={
                          this.state.HeatMapConfigDataOpportunity
                        }
                        HeatMapConfigDataThreat={
                          this.state.HeatMapConfigDataThreat
                        }
                        dynamicHeatmapProbabilityRange={
                          this.state.dynamicHeatmapProbabilityRange
                        }
                      />
                    )}
                  />
                  {/* <Column
                field="overAll"
                title="OverAll Impact"
                width="100px"
                sortable={false}
                editable={false}
                cell={(props) => (
                  <OverallComponenant {...props} onEditCell={this.onEditCell} />
                )}
              /> */}
                  {/* New  */}

                  <Column
                    field="preRiskScore"
                    title="Risk Score (Pre)"
                    filter={"numeric"}
                    width="80px"
                    editable={false}
                    headerClassName={this.setClassName("preRiskScore")}
                    columnMenu={(props) => (
                      <ColumnMenuFilter
                        {...props}
                        getSelectedColumn={this.getSelectedColumn}
                      />
                    )}
                  />

                  {isPrime && (
                    <Column
                      field="preWeightedRiskScore"
                      title="Prime Risk Score (Pre)"
                      filter={"numeric"}
                      width="80px"
                      editable={false}
                      cell={(props) => (
                        <td>
                          <span>
                            {props.dataItem.isPrimeWorkstreams &&
                            secureLocalStorage.getItem("isPrime") === true
                              ? props.dataItem.preWeightedRiskScore
                              : ""}
                          </span>
                        </td>
                      )}
                      columnMenu={(props) => (
                        <ColumnMenuFilter
                          {...props}
                          getSelectedColumn={this.getSelectedColumn}
                        />
                      )}
                      headerClassName={this.setClassName(
                        "preWeightedRiskScore"
                      )}
                    />
                  )}

                  <Column
                    field="currentRiskScore"
                    title="Risk Score (Current)"
                    filter={"numeric"}
                    width="80px"
                    editable={false}
                    cell={(props) => (
                      <td>
                        <span className="turquoiseBlue">
                          {props.dataItem.currentRiskScore}
                        </span>
                      </td>
                    )}
                    headerClassName={this.setClassName("currentRiskScore")}
                    columnMenu={(props) => (
                      <ColumnMenuFilter
                        {...props}
                        getSelectedColumn={this.getSelectedColumn}
                      />
                    )}
                  />

                  {isPrime && (
                    <Column
                      field="currentWeightedRiskScore"
                      title="Prime Risk Score (Current)"
                      filter={"numeric"}
                      width="80px"
                      editable={false}
                      cell={(props) => (
                        <td>
                          <span className="turquoiseBlue">
                            {props.dataItem.isPrimeWorkstreams &&
                            secureLocalStorage.getItem("isPrime") === true
                              ? props.dataItem.currentWeightedRiskScore
                              : ""}
                          </span>
                        </td>
                      )}
                      headerClassName={this.setClassName(
                        "currentWeightedRiskScore"
                      )}
                      columnMenu={(props) => (
                        <ColumnMenuFilter
                          {...props}
                          getSelectedColumn={this.getSelectedColumn}
                        />
                      )}
                    />
                  )}

                  <Column
                    field="postRiskScore"
                    title="Risk Score (Post)"
                    filter={"numeric"}
                    width="80px"
                    editable={false}
                    cell={(props) => (
                      <td>
                        <span className="yellowCell">
                          {props.dataItem.postRiskScore}
                        </span>
                      </td>
                    )}
                    headerClassName={this.setClassName("postRiskScore")}
                    columnMenu={(props) => (
                      <ColumnMenuFilter
                        {...props}
                        getSelectedColumn={this.getSelectedColumn}
                      />
                    )}
                  />

                  {isPrime && (
                    <Column
                      field="postWeightedRiskScore"
                      title="Prime Risk Score (Post)"
                      filter={"numeric"}
                      width="80px"
                      editable={false}
                      cell={(props) => (
                        <td>
                          <span className="yellowCell">
                            {props.dataItem.isPrimeWorkstreams &&
                            secureLocalStorage.getItem("isPrime") === true
                              ? props.dataItem.postWeightedRiskScore
                              : ""}
                          </span>
                        </td>
                      )}
                      headerClassName={this.setClassName(
                        "postWeightedRiskScore"
                      )}
                      columnMenu={(props) => (
                        <ColumnMenuFilter
                          {...props}
                          getSelectedColumn={this.getSelectedColumn}
                        />
                      )}
                    />
                  )}
                  {/* End  */}
                  {this.state.impactColumns}
                  <Column
                    field="impactComments"
                    title="Consequences"
                    width="120px"
                    editable={false}
                    columnMenu={(props) => (
                      <ColumnMenuFilter
                        {...props}
                        getSelectedColumn={this.getSelectedColumn}
                      />
                    )}
                    headerClassName={this.setClassName("impactComments")}
                  />
                  <Column
                    field="progress"
                    title="Progress Status"
                    width="120px"
                    editable={false}
                    cell={(props) => (
                      <td title={props.dataItem.progress}>
                        {props.dataItem.progress}
                      </td>
                    )}
                  />
                  <Column
                    field="proximityDate"
                    title="Proximity Date"
                    width="120px"
                    editor="date"
                    filter={"date"}
                    editable={false}
                    format="{0:dd-MMM-yyyy}"
                    columnMenu={(props) => (
                      <ColumnMenuFilter
                        {...props}
                        getSelectedColumn={this.getSelectedColumn}
                      />
                    )}
                    headerClassName={this.setClassName("proximityDate")}
                  />
                  <Column
                    field="owner"
                    title="Owner"
                    width="120px"
                    editable={false}
                    columnMenu={(props) => (
                      <SingleDropDownCheckboxCommonFilter
                        {...props}
                        filterData={this.state.userList}
                        existingFilter={this.state.existingFilter}
                        filterChangeV={this.filterChangeV}
                        clearFilter={this.clearFilter}
                      />
                    )}
                    headerClassName={this.setClassName("owner")}
                    // columnMenu={ColumnMenu}
                  />
                  <Column
                    field="riskFieldsCompletion"
                    title="% of fields completed"
                    width="120px"
                    editable={false}
                    columnMenu={(props) => (
                      <ColumnMenuFilter
                        {...props}
                        getSelectedColumn={this.getSelectedColumn}
                      />
                    )}
                    headerClassName={this.setClassName("riskFieldsCompletion")}
                  />
                  <Column
                    field="createdDate"
                    width="100px"
                    title="Created Date"
                    filter={"date"}
                    format="{0:dd-MMM-yyyy}"
                    editable={false}
                    columnMenu={(props) => (
                      <ColumnMenuFilter
                        {...props}
                        getSelectedColumn={this.getSelectedColumn}
                      />
                    )}
                    headerClassName={this.setClassName("createdDate")}
                  />
                  <Column
                    field="createdByName"
                    width="100px"
                    title="Created By"
                    editable={false}
                    columnMenu={(props) => (
                      <ColumnMenuCheckboxFilter
                        {...props}
                        data={this.state.riskList}
                        getSelectedColumn={this.getSelectedColumn}
                      />
                    )}
                    headerClassName={this.setClassName("createdByName")}
                  />
                  <Column
                    field="updatedDate"
                    title="updated Date"
                    width="120px"
                    editor="date"
                    filter={"date"}
                    editable={false}
                    format="{0:dd-MMM-yyyy}"
                    columnMenu={(props) => (
                      <ColumnMenuFilter
                        {...props}
                        getSelectedColumn={this.getSelectedColumn}
                      />
                    )}
                    headerClassName={this.setClassName("updatedDate")}
                  />
                  <Column
                    field="updatedBy"
                    title="updated By"
                    width="120px"
                    editable={false}
                    columnMenu={(props) => (
                      <ColumnMenuCheckboxFilter
                        {...props}
                        data={this.state.riskList}
                        getSelectedColumn={this.getSelectedColumn}
                      />
                    )}
                    headerClassName={this.setClassName("updatedBy")}
                  />
                  <Column
                    field="isClosed"
                    title="Status"
                    width="70px"
                    // editor="boolean"
                    editable={false}
                    cell={(props) => (
                      <StatusComponent
                        {...props}
                        onEditCell={this.onEditCell}
                      />
                    )}
                    filter={"boolean"}
                    columnMenu={(props) => (
                      <ColumnMenuCheckboxFilter
                        {...props}
                        data={this.state.riskList}
                        getSelectedColumn={this.getSelectedColumn}
                      />
                    )}
                    headerClassName={this.setClassName("isClosed")}
                  />
                  <Column
                    field="closedDate"
                    title="Closed Date"
                    width="120px"
                    editor="date"
                    filter={"date"}
                    editable={false}
                    format="{0:dd-MMM-yyyy}"
                    columnMenu={(props) => (
                      <ColumnMenuFilter
                        {...props}
                        getSelectedColumn={this.getSelectedColumn}
                      />
                    )}
                    headerClassName={this.setClassName("closedDate")}
                  />
                </Grid>
              </div>
            </div>
          )}
        {this.props.chartData.isActionWidget &&
          this.props.chartData.reportType !== "Task" &&
          this.props.chartData.reportType !== "TaskAction" && (
            <div className="tblCont riskRegister dataGrids reportsGrid">
              <ActionDataSetView
                {...this.props}
                mitigationData={this.state.mitigationData}
                mitigationDataTemp={this.state.mitigationDataTemp}
                mitigationFilterQuery={this.mitigationFilterQuery}
                getSelectedIds={this.getSelectedIds}
                customFieldsmaster={
                  this.state.customFieldsmasterMiti
                    ? this.state.customFieldsmasterMiti
                    : []
                }
                riskTypemaster={
                  this.state.riskTypemasterMiti
                    ? this.state.riskTypemasterMiti
                    : []
                }
                userList={this.state.userList}
                actionTypeList={this.state.actionTypeList}
              ></ActionDataSetView>
            </div>
          )}

        {this.props.chartData && this.props.chartData.reportType === "Task" && (
          <div className="tblCont riskRegister dataGrids reportsGrid">
            <ViewTaskDataset
              {...this.props}
              taskDataList={this.state.taskDataList}
              taskDataListTemp={this.state.taskDataList}
              mitigationFilterQuery={this.mitigationFilterQuery}
              getSelectedIds={this.getSelectedIds}
              customFieldsmaster={
                this.state.customFieldsmasterMiti
                  ? this.state.customFieldsmasterMiti
                  : []
              }
              riskTypemaster={
                this.state.riskTypemasterMiti
                  ? this.state.riskTypemasterMiti
                  : []
              }
            ></ViewTaskDataset>
          </div>
        )}

        {this.props.chartData &&
          this.props.chartData.reportType === "TaskAction" && (
            <div className="tblCont riskRegister dataGrids reportsGrid">
              <ViewActivitiesDataset
                {...this.props}
                taskDataList={this.state.taskActionDataList}
                taskDataListTemp={this.state.taskActionDataList}
                mitigationFilterQuery={this.mitigationFilterQuery}
                getSelectedIds={this.getSelectedIds}
                customFieldsmaster={
                  this.state.customFieldsmasterMiti
                    ? this.state.customFieldsmasterMiti
                    : []
                }
                riskTypemaster={
                  this.state.riskTypemasterMiti
                    ? this.state.riskTypemasterMiti
                    : []
                }
              ></ViewActivitiesDataset>
            </div>
          )}
      </div>
    );
  }
}
